module.exports = __webpack_public_path__ + "static/media/twig.85ccf097.png";